/**
 * Imaging devices (V24, audit IC-10 / ADM-03): Settings > Imaging devices.
 * Pair a capture PC running Velora Capture (8-character code), see each PC's
 * sensors and cameras online, set per-device orientation and foot pedal,
 * revoke a PC, and turn the office flag `imaging_capture_agent` on or off.
 * API: `/v1/imaging-capture`. Also exports the agent capture source and the
 * sensor status the imaging capture surface and the top-bar pill use.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'imaging-devices',
    title: 'Imaging devices',
    version: '0.1.0',
    owner: 'WP17-CAPTURE-AGENT',
    entitlementKey: null,
    permissions: ['imaging.view', 'imaging.capture', 'settings.manage'],
    routes: [
      {
        id: 'devices',
        path: '/settings/imaging-devices',
        title: 'Imaging devices',
        officeScope: 'location-or-all',
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Imaging devices',
        group: 'settings',
        routeId: 'devices',
        icon: 'scan-line',
        order: 936,
        permission: 'imaging.view',
      },
    ],
    commands: [
      {
        id: 'imaging-devices.open',
        title: 'Imaging devices',
        keywords: [
          'x-ray',
          'sensor',
          'capture',
          'pair',
          'agent',
          'camera',
          'pedal',
          'dexis',
          'schick',
          'twain',
        ],
        routeId: 'devices',
      },
      {
        id: 'imaging-devices.pair',
        title: 'Pair a capture PC',
        keywords: ['pairing code', 'x-ray', 'sensor', 'velora capture'],
        routeId: 'devices',
      },
    ],
    sseEntityKeys: ['imaging_agent', 'imaging_device', 'imaging_capture_session'],
    phiReadPoints: [],
  }),
  pages: {
    devices: () => import('./ImagingDevicesPage.js'),
  },
});
